module.exports = __webpack_public_path__ + "img/magnifying-glass.8246dbb9.svg";